import { Audit } from 'entities/entity';
import { Client, Options } from './client';

/**
 * @deprecated - see https://bit.ly/3u0WlF7 for more details.
 */
export function simpleClient<T>(url?: string): Client<T> {
  const options: Options<T> = {
    url,
    mapToRequest: (x: T) => x,
    mapFromResponse: (response: T & { id: string }) => ({ id: response.id, entity: response }),
  };

  return new Client(options);
}

interface AuditEvent {
  time: number;
  userId?: string;
}

export interface KotlinAudit {
  // TODO: (ac 23/1/2019) - Neither of these are optional, but this is necessary until
  // we fix the old apis using the old audit format (see below).
  created?: AuditEvent;
  lastUpdated?: AuditEvent;
}

export interface KotlinResponse<T> {
  id: string;
  value: T;
  // TODO: (ac 23/1/2019) - Should be only KotlinAudit, fix when all APIs catch up
  audit: Audit & KotlinAudit;
  parentResourceIds?: { [idName: string]: string };
}

interface WithAudit {
  audit: Audit;
}

/**
 * @deprecated - see https://bit.ly/3u0WlF7 for more details.
 */
export function mapKotlinResponse<T>(response: KotlinResponse<T>, addParentIds?: true): T & WithAudit {
  return Object.assign({}, response.value, {
    audit: {
      createdAt: response.audit.createdAt || (response.audit.created && response.audit.created.time),
      createdBy: response.audit.createdBy || (response.audit.created && response.audit.created.userId),
      lastUpdatedAt: response.audit.lastUpdatedAt || (response.audit.lastUpdated && response.audit.lastUpdated.time),
      lastUpdatedBy: response.audit.lastUpdatedBy || (response.audit.lastUpdated && response.audit.lastUpdated.userId),
    },
    ...(addParentIds ? response.parentResourceIds : {}),
  });
}

/**
 * @deprecated - see https://bit.ly/3u0WlF7 for more details.
 */
export function kotlinRestAPIClient<T>(url?: string): Client<T, T, KotlinResponse<T>> {
  const options: Options<T, T, KotlinResponse<T>> = {
    url,
    mapToRequest: (x: T) => x,
    mapFromResponse: (resp: KotlinResponse<T>) => ({
      id: resp.id,
      entity: mapKotlinResponse(resp),
    }),
  };

  return new Client(options);
}
